<!---

TODO: Remove conditional header handling and repeating of navbar-nav. This has to be handled in a better way!

-->

<div class="header-bg">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <nav class="navbar navbar-expand-lg navbar-dark">
          <button (click)="isMenuCollapsed = !isMenuCollapsed" class="navbar-toggler" type="button">
            <span class="icon-Menu-Hamburger"></span>
          </button>

          <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
            <ul class="navbar-nav mr-auto" *ngIf="pageName === 'appPage'">
              <li class="nav-item nav-menu-icon ngbDropDown grid-dropDown" *ngIf="appListData.length > 0">
                <div class="d-inline-block" ngbDropdown>
                  <button class="btn" id="nav-dropdown1" ngbDropdownToggle>
                    <div class="grid-background"><span class="icon-Menu-Grid"></span></div>
                  </button>
                  <div aria-labelledby="nav-dropdown" ngbDropdownMenu>
                    <div class="scrollable-container">
                      <div class="app-container scrollable">
                        <ng-container *ngFor="let appData of appListData; let i = index">
                          <!-- <div class="divider" *ngIf="appData.visible && i > 0"></div> -->
                          <div class="divider" *ngIf="appData.visibility"></div>
                          <!-- <div *ngIf="appData.visible"> -->
                          <div
                            *ngIf="appData.visibility && (appData.appCategory | translate) !== 'Customize Dashboard'"
                          >
                            <h6>
                              {{ appData.appCategory | translate }}
                            </h6>
                            <ul class="d-flex">
                              <ng-container *ngFor="let app of appList">
                                <!-- <ng-container *ngIf="app.groupVisibility | async"> -->
                                <li
                                  *ngIf="app.appCategory === appData.appCategory && app.appID !== 'customizeDashboard'"
                                >
                                  <a (click)="hamburgerMenuAction(app.primaryRoute)">
                                    <img [src]="app.iconImage" alt="" />
                                    <p class="pageTitle">{{ app.label | translate }}</p>
                                  </a>
                                </li>
                                <!-- </ng-container> -->
                              </ng-container>
                            </ul>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item">
                <!-- Todo: based on role app from language file will change -->
                <a class="navbar-brand themed-link no-pointer">{{ routeConfig.title | translate }}</a>
              </li>
              <li class="nav-item ngbDropDown" *showIfHasFeature="{ feature: 'header.accountDropdown' }">
                <div class="d-inline-block" ngbDropdown>
                  <button class="btn" id="nav-dropdown55" ngbDropdownToggle>
                    Acme corporation / Ticketing division
                  </button>
                  <div aria-labelledby="nav-dropdown" ngbDropdownMenu>
                    <button ngbDropdownItem>Action - 1</button>
                    <button ngbDropdownItem>Another Action</button>
                    <button ngbDropdownItem>Something else is here</button>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="navbar-nav mr-auto" *ngIf="pageName === 'login'">
              <li class="nav-item">
                <a class="navbar-brand themed-link no-pointer">{{ routeConfig.title | translate }}</a>
              </li>
              <li class="nav-item login-item">
                <a href="#" class="themed-link">Capgemini Intelligent Automation Platform</a>
              </li>
            </ul>

            <ul class="navbar-nav nav-right-items" *ngIf="pageName === 'appPage'">
              <li
                class="nav-item"
                [ngClass]="!searchExpand ? '' : 'no-inner-space'"
                *showIfHasFeature="{ feature: 'header.globalSearch' }"
              >
                <a class="themed-link pos-rel" (click)="toggleSearch(true)">
                  <input
                    [ngClass]="!searchExpand ? 'width-zero' : 'searchExpand'"
                    [placeholder]="'lang.commonComponents.header.HeaderComponent.searchPlaceHolder' | translate"
                    autocomplete="off"
                    [(ngModel)]="serachKeyword"
                    id="search"
                    name="search"
                    type="search"
                  />
                  <span class="icon-Search"></span>
                </a>
                <button
                  *ngIf="searchExpand"
                  class="btn custom-btn-hd no-border ml5"
                  (click)="globalSearch(serachKeyword)"
                >
                  {{ 'lang.commonComponents.commonWords.search' | translate }}
                </button>
              </li>

              <li class="nav-item ngbDropDown noti-dropdown" *showIfHasFeature="{ feature: 'header.notifications' }">
                <div class="d-inline-block" ngbDropdown>
                  <button class="btn" id="nav-dropdown2" ngbDropdownToggle>
                    <span class="icon-Notifications p-2 highlight"></span>
                  </button>
                  <div aria-labelledby="nav-dropdown" ngbDropdownMenu>
                    <button ngbDropdownItem>
                      <span class="ciap-icon icon-Notifications"></span>
                      <span>{{ 'lang.commonComponents.header.HeaderComponent.serviceBreakDuring' | translate }}</span>
                    </button>
                    <button ngbDropdownItem>
                      <span class="ciap-icon icon-Info"></span>
                      <span>{{
                        'lang.commonComponents.header.HeaderComponent.newXXFeatureAvailable' | translate
                      }}</span>
                    </button>
                    <button ngbDropdownItem>
                      <span class="ciap-icon icon-Notifications"></span>
                      <span>{{
                        'lang.commonComponents.header.HeaderComponent.ServiceBreakOnSaturdayDuring' | translate
                      }}</span>
                    </button>
                    <button ngbDropdownItem>
                      <span class="ciap-icon icon-Notifications"></span>
                      <span>{{ 'lang.commonComponents.header.HeaderComponent.ServiceBreakDuring6' | translate }}</span>
                    </button>
                    <button class="viewAll-btn" ngbDropdownItem>
                      {{ 'lang.commonComponents.header.HeaderComponent.viewAll' | translate }}
                    </button>
                  </div>
                </div>
              </li>
              <li class="nav-item user-name-link custom-btn-hd">
                <ul class="navbar-nav ml-auto lang-bar noselect">
                  <li class="nav-item" display="dynamic" ngbDropdown placement="bottom-right">
                    <a
                      class="nav-link themed-link"
                      id="navbarDropdown3"
                      ngbDropdownToggle
                      role="button"
                      style="cursor: pointer;font-weight: 200;"
                    >
                      {{ selectedLanguage | uppercase }}
                      <a>
                        <span class=" icon-Person"></span>
                        {{ userProfile?.displayName || userProfile?.given_name }}
                      </a>
                    </a>
                    <div aria-labelledby="navbarDropdown3" class="dropdown-menu" ngbDropdownMenu>
                      <button (click)="profileAction('profileSetting')" ngbDropdownItem>
                        <span class="ciap-icon icon-Settings"></span>
                        <span class="profileMenu">{{
                          'lang.commonComponents.header.appSpecific.ticketingApp.profileNSetting' | translate
                        }}</span>
                      </button>
                      <button
                        (click)="profileAction('admin')"
                        ngbDropdownItem
                        *showIfHasFeature="{ feature: 'userSettingMenu.admin' }"
                      >
                        <span class="ciap-icon icon-Person "></span>
                        <span class="profileMenu">Admin</span>
                      </button>
                      <button (click)="profileAction('logout')" ngbDropdownItem>
                        <span class="ciap-icon icon-Logout"></span>
                        <span class="profileMenu">{{
                          'lang.commonComponents.header.appSpecific.ticketingApp.logout' | translate
                        }}</span>
                      </button>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
<!-- <div class="chatBot" (click)="toggleChatBot(true)" *ngIf="isUserAuthenticated() && !chatBotEnabled">
  <img src="../../../../assets/images/chatbot_button.gif" alt="" />
</div> -->
<!-- <app-go-to-top></app-go-to-top> -->
